import { Box, ButtonNew, ColorOptions, IconButton, Spacer } from '@jfs/ui-new'
import { Colors } from '../../util/util'

const getEditDeleteView = (
  itemData: any,
  downloadReportFile: (data: any) => void,
  deleteReportFile: (data: any) => void,
) => {
  const onDelete = () => {
    deleteReportFile(itemData)
  }

  const onDownload = () => {
    downloadReportFile(itemData)
  }
  return (
    <Box w={200} flexDirection={'row'} marginRight={120}>
      <ButtonNew
        textType={'bodyMedium12'}
        borderWidth={1}
        borderColor={'TRANSPARENT'}
        borderRadius={4}
        titleColor={Colors.REPORT_PRIMARY}
        height={32}
        color={Colors.DISABLED_PRIMARY}
        hoverColor={'GREY_MATTE' as ColorOptions}
        title={'Edit Configuration'}
        icon={'EDIT'}
        iconPaddingRight={'6'}
        onPress={onDownload}
        testID={'btn-edit'}
        disabled={itemData?.status === 'In Progress' || itemData?.status === 'Failed'}
      />
      <Spacer direction={'horizontal'} size={16} />
      <Box
        // borderColor={'DISABLED_GREY'}
        borderRadius={6}
        height={32}
        alignItems={'center'}
        bg={Colors.DISABLED_PRIMARY}
        justifyContent={'center'}
        w={32}>
        <IconButton onPress={onDelete} testID="btn-delete" id={'DELETE'} size={17} color={Colors.REPORT_PRIMARY} />
      </Box>
    </Box>
  )
}

export { getEditDeleteView }
